export default __webpack_public_path__ + "static/media/99ac49b1c78813b0dfa9a537669a9ca41599577404517.1fbefda2.webp";